import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/scenes'
)({
  component: ScenesLayout,
})

function ScenesLayout() {
  return <FeatureGate feature='image' />
}
